import { searchReport } from '@/reports/searchReport';
import type { PersonRequestBody } from '@/reports/searchReport';

export type DirectPersonSearchParams = {
  bvid?: string;
  'h-captcha-response'?: string;
  showPartialAddresses?: boolean;
};

export const peopleSearchParams = (
  params: DirectPersonSearchParams
): string => {
  return Object.entries(params)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value || '')}`
    )
    .join('&');
};

export async function personSearch(params: DirectPersonSearchParams) {
  const body: PersonRequestBody = {
    report_type: 'detailed_person_report',
    meta: {
      person_id: params.bvid || '',
      report_flags: params.showPartialAddresses
        ? ['dd_plan%3Dzacapu', 'verified_customer%3Dfalse']
        : [],
    },
    'h-captcha-response': params['h-captcha-response'] || '',
  };

  return searchReport(body);
}
